// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"292":"dc6a055a","311":"5ffe1889","761":"d0deef33"}[chunkId] || chunkId) + "." + {"101":"96f1caf84cc0151e","269":"6868256b0228fbcb","292":"8656b07b0acab5ac","311":"8628ff44dff6c038","761":"3ca5c1b04009cb55"}[chunkId] + ".js";
};